import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gamingcontroller',
  templateUrl: './gamingcontroller.page.html',
  styleUrls: ['./gamingcontroller.page.scss'],
})
export class GamingcontrollerPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }



  clickbtnx() {
    alert("x")
  }
  clickbtny() {
    alert("y")
  }
  clickbtna() {
    alert("a")
  }
  clickbtnb() {
    alert("b")
  }

  clickbtnup() {
    alert("up")
  }

  clickbtnleft() {
    alert("left")
  }

  clickbtnright() {
    alert("right")
  }

  clickbtndown() {
    alert("down")
  }

  clickbtnselect() {
    alert("select")
  }

  clickbtnstart() {
    alert("start")
  }





}
